module.exports = __webpack_public_path__ + "img/skrin.608edee6.svg";